import { LAYOUTS } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { continueEditAction, Go_Next_Action, goBack, needHelp } from './actions';
import { updateApplicationContextFromApi, isFromJupiter, getContactUsDetails } from '../../../configs/utils';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (data, avaialbleCredit, remainingSteps, height, showEditLimit, isEnhancedLimit, isFromJupiterPlatform, contactUsDetails) => ({
    layout: {
        id: ROUTE.KYC_STEPPER,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "kycCard", type: WIDGET.KYC_CARD },
        ],
    },
    datastore: {
        kycCard: {
            creditLimit: avaialbleCredit,
            remainingSteps: remainingSteps,
            showEditLimit: showEditLimit,
            isFromJupiterPlatform: isFromJupiterPlatform,
            height: height,
            stepperData: data,
            bottomCTAAction: {
                type: ACTION.GO_TO_AADHAR_INIT,
                routeId: ROUTE.KYC_STEPPER,
                payload: {},
            },
            goBack: {
                routeId: ROUTE.KYC_STEPPER,
                type: ACTION.GO_BACK,
                payload: { id: 'bt_kycStepper_needHelp' }
            },
            needHelp: {
                routeId: ROUTE.KYC_STEPPER,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_kycStepper_needHelp' }
            },
            continueEditAction: {
                type: ACTION.CONTINUE_EDIT,
                routeId: ROUTE.KYC_STEPPER,
                payload: {},
            },
            loading: false,
            isEnhancedLimit: isEnhancedLimit,
            contactUsDetails: contactUsDetails
        },
    },
});
export const kycStepperMF = {
    onLoad: async ({ network, instrumentTrack, getHeight, removeWidgets }) => {
        await removeWidgets(ROUTE.KYC_STEPPER, [
            { id: 'kycCard', type: WIDGET.KYC_CARD }
        ]);
        const user = await SharedPropsService.getUser();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const stepperResopnse = await network.post(`${api.getStepper}`, {
            applicationId: applicationId,
        }, { headers: await getAppHeader() });
        const getPledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        let completedSteps = 0;
        for (let i = 0; i < stepperResopnse.data.borrowerViewStepperMap.length; i++) {
            if (stepperResopnse.data.borrowerViewStepperMap[i].status === "COMPLETED") {
                completedSteps++;
            }
        }
        const remainingSteps = stepperResopnse.data.borrowerViewStepperMap.length - completedSteps;
        instrumentTrack('APPLICATION_STEPS_PAGE_VIEWED', {
            "total_steps": stepperResopnse.data.borrowerViewStepperMap.length,
            "steps_completed": completedSteps
        });
        await updateApplicationContextFromApi(network, applicationId);
        const userData = await SharedPropsService.getUser();
        const accountId = userData.linkedApplications[0].accountId;
        const shouldShowEditLimit = await network.get(`${api.showEnableLimitV2}${applicationId}`, {
            headers: await getAppHeader()
        });
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
        const isFromJupiterPlatform = await isFromJupiter();
        const contactUsDetails = await getContactUsDetails();
        const showEditLimit = shouldShowEditLimit.data.isEnabled;
        return Promise.resolve(template(stepperResopnse.data.borrowerViewStepperMap, getPledgeDetails.data.stepResponseObject.requestCreditLimit + getPledgeDetails.data.stepResponseObject.approvedCreditLimit, remainingSteps, getHeight(), showEditLimit, isEnhancedLimit, isFromJupiterPlatform, contactUsDetails));
    },
    actions: {
        [ACTION.GO_TO_AADHAR_INIT]: Go_Next_Action,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_BACK]: goBack,
        [ACTION.CONTINUE_EDIT]: continueEditAction,
    },
    clearPrevious: true,
};
